
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerJungleLogKnot from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogKnot";
import PlatformMarkerLogMid from "../../editor/platform-markers/shipwreck/PlatformMarkerLogMid";
import MoverData from "../../../components/platformer/MoverData";
import PositionMarker from "../../editor/PositionMarker";
import RelicMarker from "../../editor/RelicMarker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunkRelic1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 586, y ?? 502);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 3796, 7);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -848, 7);
    this.add(editor_bounds_left);

    // platformLogKnot
    const platformLogKnot = new PlatformMarkerJungleLogKnot(scene, 1075, -620);
    this.add(platformLogKnot);

    // platformLog
    const platformLog = new PlatformMarkerLogMid(scene, 1744, -698);
    this.add(platformLog);

    // positionMarker_Barrel1_start
    const positionMarker_Barrel1_start = new PositionMarker(scene, 1744, -698);
    this.add(positionMarker_Barrel1_start);

    // positionMarker_Barrel1_end
    const positionMarker_Barrel1_end = new PositionMarker(scene, 1881, -698);
    this.add(positionMarker_Barrel1_end);

    // relicMarker
    const relicMarker = new RelicMarker(scene, 2606, -750);
    this.add(relicMarker);

    // platformLogKnot_1
    const platformLogKnot_1 = new PlatformMarkerJungleLogKnot(scene, 2603, -658);
    this.add(platformLogKnot_1);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1194, -716);
    this.add(gemMarker);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 1160, -771);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 1124, -719);
    this.add(gemMarker_11);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, -489, -104);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, -763, -104);
    this.add(pole_long_float_png);

    // gemMarker_30
    const gemMarker_30 = new SmallGemMarker(scene, -142, -307);
    this.add(gemMarker_30);

    // gemMarker_31
    const gemMarker_31 = new SmallGemMarker(scene, -606, -307);
    this.add(gemMarker_31);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, -356, -245);
    this.add(platformMarkerLogLong);

    // pole_long_float_png_8
    const pole_long_float_png_8 = new DecorationFloatingPoleLong(scene, -198, -104);
    this.add(pole_long_float_png_8);

    // pole_long_float_png_9
    const pole_long_float_png_9 = new DecorationFloatingPoleLong(scene, 72, -104);
    this.add(pole_long_float_png_9);

    // pole_long_float_png_10
    const pole_long_float_png_10 = new DecorationFloatingPoleLong(scene, 2146, -111);
    this.add(pole_long_float_png_10);

    // pole_long_float_png_11
    const pole_long_float_png_11 = new DecorationFloatingPoleLong(scene, 1882, -111);
    this.add(pole_long_float_png_11);

    // pole_long_float_png_12
    const pole_long_float_png_12 = new DecorationFloatingPoleLong(scene, 1591, -111);
    this.add(pole_long_float_png_12);

    // pole_long_float_png_13
    const pole_long_float_png_13 = new DecorationFloatingPoleLong(scene, 1318, -111);
    this.add(pole_long_float_png_13);

    // platformMarkerLogLong_3
    const platformMarkerLogLong_3 = new PlatformMarkerJungleLogLong(scene, 1732, -241);
    this.add(platformMarkerLogLong_3);

    // gemMarker_32
    const gemMarker_32 = new SmallGemMarker(scene, 3126, -314);
    this.add(gemMarker_32);

    // gemMarker_33
    const gemMarker_33 = new SmallGemMarker(scene, 3357, -317);
    this.add(gemMarker_33);

    // pole_long_float_png_2
    const pole_long_float_png_2 = new DecorationFloatingPoleLong(scene, 3440, -107);
    this.add(pole_long_float_png_2);

    // pole_long_float_png_3
    const pole_long_float_png_3 = new DecorationFloatingPoleLong(scene, 3176, -107);
    this.add(pole_long_float_png_3);

    // pole_long_float_png_4
    const pole_long_float_png_4 = new DecorationFloatingPoleLong(scene, 2885, -107);
    this.add(pole_long_float_png_4);

    // pole_long_float_png_5
    const pole_long_float_png_5 = new DecorationFloatingPoleLong(scene, 2612, -107);
    this.add(pole_long_float_png_5);

    // platformMarkerLogLong_1
    const platformMarkerLogLong_1 = new PlatformMarkerJungleLogLong(scene, 3026, -237);
    this.add(platformMarkerLogLong_1);

    // platformLogKnot_2
    const platformLogKnot_2 = new PlatformMarkerJungleLogKnot(scene, 405, -424);
    this.add(platformLogKnot_2);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 496, -572);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 460, -523);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 524, -520);
    this.add(gemMarker_4);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -608, -298);
    this.add(checkpointMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1776, -844);
    this.add(gemMarker_1);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 1774, -900);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 1776, -785);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 1832, -866);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 1832, -811);
    this.add(gemMarker_8);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 1890, -839);
    this.add(gemMarker_9);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, -75, -307);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, -111, -364);
    this.add(gemMarker_13);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // platformLog (components)
    const platformLogMoverData = new MoverData(platformLog);
    platformLogMoverData.startMarker = positionMarker_Barrel1_start;
    platformLogMoverData.endMarker = positionMarker_Barrel1_end;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
